import Loader from "CommonComponent/Loader";
import { RENTAL_MODULE, TOUR_MODULE } from "Constant/UsreConstant";
import {
  acceptDocumentUploadValidation,
  emailValidation,
  maxFileSizeResourceMb,
  maxImageSizeResourceMb,
} from "Constant/common";
import { en_lang } from "Constant/en_lang_operator";
import {
  addNewTicketAction,
  getTicketCitiesSuggestionData,
  getTicketContentData,
} from "Rental-admin/Redux/Actions/ticketManagementAction";
import React, { lazy, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchingCountryJson } from "rental-operator/redux/Actions/CountryAction";
import { uploadAzureData } from "rental-operator/redux/Actions/UploadFileAzureAction";
import { displayNotification } from "store/action";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import { verifyCaptchaApi } from "Constant/apiConstant";
import axios from "axios";
const TermConditionModal = lazy(() =>
  import("../../rental-operator/common-ui/TermCondition")
);
const PrivacyPolicyModal = lazy(() =>
  import("../../rental-operator/common-ui/PrivacyPolicyModal")
);

const assetPath = process.env.REACT_APP_AZUR_ASSET_PATH;
const closeIcon = assetPath + "/main/assets/img/icons/close-icon.svg";

const AddNewTicketComponent = ({ homepage }) => {
  const history = useHistory();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const dispatch = useDispatch();
  const recaptchaRef = useRef();

  const { handleSubmit, register, errors, setValue, reset, getValues, watch } =
    useForm();

  const [image, setImage] = useState([]);
  const [ticketFile, setTicketFileName] = useState();
  const [ticketFileSize, setTicketFileSize] = useState();
  const [imagesTemp, setImagesTemp] = useState([]);
  const [uploadAzureTicketData, setuploadAzureTicketData] = useState();
  const [subCategories, setSubCategories] = useState([]);
  const [show, setShow] = useState(false);
  const [countrycode, setCountryCode] = useState("");
  const [showTC, setShowTC] = useState(false);
  const [showPP, setShowPP] = useState(false);
  const [filteredCities, setFilteredCities] = useState([]);

  const ticketContentData = useSelector(
    (state) => state.ticketManagementReducer.ticketContentData
  );

  const ticketCitiesSuggestionData = useSelector(
    (state) => state.ticketManagementReducer.ticketCitiesSuggestionData
  );

  const addNewTicketLoading = useSelector(
    (state) => state.ticketManagementReducer.addNewTicketLoading
  );

  const loading = useSelector((state) => state.AzureUploadReducer.loading);

  const countryList = useSelector((state) => state.Country.countriesJson);

  const uniqueCallingCode = [
    ...new Set(countryList.map((item) => item.phone_code)),
  ];
  const loginDetail = useSelector((state) => state.OperatorLoginReducer?.data);
  console.log("logindetailticket", loginDetail);

  const ImageFileDetail = {};

  useEffect(() => {
    if (loginDetail?.data?.operatorDetails?.muserId) {
      const country = loginDetail?.data?.operatorAccount?.Country;
      setValue(
        "callingCode",
        loginDetail?.data?.operatorAccount?.contact?.mobile?.callingCode
      );
      setValue(
        "mobileNo",
        loginDetail?.data?.operatorAccount?.contact?.mobile?.number
      );
      setValue("email", loginDetail?.data?.operatorAccount?.contact?.email);
      setValue("country", country);
      setCountryCode(country);
      setValue("city", loginDetail?.data?.operatorAccount?.City);
    }
  }, [loginDetail]);

  // console.log("getProfileDetail", getProfileDetail);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (history.location.pathname === "/add-new-ticket") {
      handleShow();
    }
  }, []);

  const handlePartnerLogin = () => {
    history.push("/partner/login-account?redirect=add-new-ticket");
  };

  const handleCallback = () => {
    if (homepage) {
      if (loginDetail) {
        setValue(
          "callingCode",
          loginDetail?.data?.operatorAccount?.contact?.mobile?.callingCode
        );
        setValue(
          "mobileNo",
          loginDetail?.data?.operatorAccount?.contact?.mobile?.number
        );
        setValue("email", loginDetail?.data?.operatorAccount?.contact?.email);
        setValue("category", "");
        setValue("country", loginDetail?.data?.operatorAccount?.Country);
        setValue("city", loginDetail?.data?.operatorAccount?.City);
        setValue("description", "");
        setValue("subCategory", "");
        setValue("acceptTC", "");
      } else {
        reset();
        setValue("country", "");
        setCountryCode("");
        setValue("city", "");
        setValue("acceptTC", "");
      }
      setuploadAzureTicketData();
      setTicketFileName();
    } else if (loginDetail?.data?.partner_module === RENTAL_MODULE) {
      history.push("/partner/support");
    } else if (loginDetail?.data?.partner_module === TOUR_MODULE) {
      history.push("/tour-partner/support");
    }
  };

  const handleSelectImages = (event) => {
    let imageSize = 0;
    let imageType = "";

    imageSize = event.target.files.item(0).size / 1024 / 1024;
    imageType = event.target.files.item(0).type.split("/")[1];
    let typeValidation =
      imageType === "pdf" ||
      imageType === "jpeg" ||
      imageType === "jpg" ||
      imageType === "png";

    let sizeValidation =
      imageType === "jpeg" || imageType === "jpg" || imageType === "png"
        ? imageSize <= maxImageSizeResourceMb
        : imageSize <= maxFileSizeResourceMb;

    if (sizeValidation && typeValidation) {
      setTicketFileSize(imageSize);
      setTicketFileName(event.target.files[0].name);

      const data = {
        containerName: "support",
        dirName: "ticket-management",
        file: event.target.files,
      };
      dispatch(uploadAzureData(data, "image", successCB, "ticket", errorCb));
    } else {
      if (!sizeValidation) {
        errorCb();
        dispatch(
          displayNotification({
            open: true,
            message:
              imageType === "jpeg" || imageType === "jpg" || imageType === "png"
                ? "File size should be less than 2MB."
                : "File size should be less than 10MB.",
            duration: 6000,
            severity: "err",
          })
        );
      }
      if (!typeValidation) {
        dispatch(
          displayNotification({
            open: true,
            message: "Please select only png, jpg/jpeg, pdf file formats.",
            duration: 6000,
            severity: "err",
          })
        );
      }
    }
  };
  const errorCb = () => {
    setTicketFileName("");
    setValue("document_upload", undefined);
  };

  const successCB = (data, type) => {
    if (type === "image") {
      setImage(imagesTemp);
      ImageFileDetail["value"] = data?.uriList[0];
      setImage([ImageFileDetail]);
      setuploadAzureTicketData([...data?.uriList]);
    }
  };

  const onCategoryChange = (e) => {
    if (e.target.value) {
      const category = ticketContentData?.categories?.find(
        (cat) => cat?.category === e.target.value
      );
      if (category) {
        setSubCategories(category?.subcategories);
      }
    } else {
      setSubCategories([]);
    }
  };

  const formSubmit = async (value) => {
    try {
      const captchaToken = await executeRecaptcha("submit_ticket");
      if (!captchaToken) {
        alert("Please complete the reCAPTCHA!");
        return;
      } else {
        console.log("captchaToken", captchaToken);
        const res = await axios.get(
          `${process.env.REACT_APP_API_ENDPOINT}${verifyCaptchaApi}${captchaToken}`,
          {
            headers: {
              app_id: "4",
            },
          }
        );

        if (res.data.code == 200) {
          const payload = {
            description: value.description,
            city: value.city,
            country: countrycode,
            category: value.category,
            subCategory: value.subCategory,
            email: loginDetail?.data?.operatorAccount?.contact?.email
              ? loginDetail?.data?.operatorAccount?.contact?.email
              : value.email,
            phone: loginDetail?.data?.operatorAccount?.contact?.mobile?.number
              ? loginDetail?.data?.operatorAccount?.contact?.mobile?.number
              : value.mobileNo,
            uploadImage: uploadAzureTicketData
              ? uploadAzureTicketData?.toString()
              : "",
            callingCode: loginDetail?.data?.operatorAccount?.contact?.mobile
              ?.callingCode
              ? loginDetail?.data?.operatorAccount?.contact?.mobile?.callingCode
              : value.callingCode,
            status: "OPEN",
          };
          dispatch(addNewTicketAction(payload, handleCallback));
        } else {
          alert("Captcha verification failed. Please try again.");
        }
      }
    } catch (error) {
      console.error("Captcha verification error:", error);
      alert("An error occurred during captcha verification.");
    }
  };

  useEffect(() => {
    dispatch(getTicketContentData());
    dispatch(fetchingCountryJson());
    dispatch(getTicketCitiesSuggestionData());
  }, [dispatch]);
  const mobileOnlyKeyValidations = /^\d{8,15}$/;

  const handleBack = () => {
    if (homepage) {
      history.push("/");
    } else {
      if (loginDetail?.data?.partner_module === RENTAL_MODULE) {
        history.push("/partner/support");
      } else if (loginDetail?.data?.partner_module === TOUR_MODULE) {
        history.push("/tour-partner/support");
      }
    }
  };
  const changeCountryCode = (e) => {
    const selectedCountry = e.target.value;
    setCountryCode(selectedCountry);

    setValue("city", "");
    setFilteredCities([]);
  };

  const handleCityInputChange = (e) => {
    console.log("ee", e.target.value);

    const inputValue = e.target.value;
    setValue("city", inputValue);
    if (countrycode === "India") {
      setFilteredCities(
        ticketCitiesSuggestionData?.cities?.filter((city) =>
          city.toLowerCase().includes(inputValue.toLowerCase())
        )
      );
    } else {
      setFilteredCities([]);
    }
  };
  const handleCitySuggestionClose = () => {
    setFilteredCities([]);
  };
  const isTCChecked = watch("acceptTC");

  const handleCheckTC = (e) => {
    setValue("acceptTC", e.target.checked);
  };

  return (
    <>
      {(addNewTicketLoading || loading) && <Loader />}
      <div className="add-new-city">
        <form className="form-white pt-0" onSubmit={handleSubmit(formSubmit)}>
          <div className="container pt-4 p-md-0">
            <div className="back-btn mt-0">
              <span onClick={handleBack}>Back</span>
            </div>
            <h2 className="newCityPageTitle">ADD New Ticket</h2>
            <div className="row">
              <div className="col-md-12">
                <h4 className="detailTitle">Ticket Details</h4>
              </div>
              <div className="col-md-6 form-input">
                <label className="mb-2">
                  Mobile Number<span className="mandatory">*</span>
                </label>

                <div className="calling-code-main position-relative">
                  <div className="form-input calling-code">
                    <select
                      className="callingCode"
                      name="callingCode"
                      ref={register({
                        // required: "Please select the calling code",
                      })}
                      disabled={
                        loginDetail?.data?.operatorAccount?.contact?.mobile
                          ?.callingCode
                      }
                    >
                      <option value="91">+91</option>
                      {uniqueCallingCode?.sort()?.map((item, index) => (
                        <option key={`calling_code_${index}`} value={`${item}`}>
                          +{item}
                        </option>
                      ))}
                    </select>
                  </div>
                  <input
                    type="text"
                    name="mobileNo"
                    placeholder="Enter Mobile No."
                    ref={register({
                      required: "Please add Mobile No.",

                      validate: (value) => mobileOnlyKeyValidations.test(value),
                    })}
                    maxLength={15}
                    minLength={8}
                    disabled={
                      loginDetail?.data?.operatorAccount?.contact?.mobile
                        ?.number
                    }
                  />
                </div>
                {errors?.mobileNo?.type === "required" && (
                  <label>
                    <span className="mandatory">
                      {errors?.mobileNo?.message}
                    </span>
                  </label>
                )}
                {errors?.mobileNo?.type === "validate" && (
                  <label>
                    <span className="mandatory">
                      Please enter valid mobile no.
                    </span>
                  </label>
                )}
              </div>
              <div className="col-md-6 form-input">
                <label className="mb-2">
                  Email ID<span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  name="email"
                  placeholder="Enter Email ID"
                  ref={register({
                    required: "Please add Email ID",
                    validate: (value) => emailValidation.test(value),
                  })}
                  disabled={loginDetail?.data?.operatorAccount?.contact?.email}
                />
                {errors?.email?.type === "required" && (
                  <label>
                    <span className="mandatory">{errors?.email?.message}</span>
                  </label>
                )}
                {errors?.email?.type === "validate" && (
                  <label>
                    <span className="mandatory">
                      Please enter valid email id
                    </span>
                  </label>
                )}
              </div>
              <div className="col-md-6 form-input">
                <label className="mb-2">
                  Country<span className="mandatory">*</span>
                </label>
                <select
                  as="select"
                  name="country"
                  ref={register({
                    required: "Please select the country",
                  })}
                  onChange={(e) => changeCountryCode(e)}
                  value={
                    getValues("country") ? getValues("country") : countrycode
                  }
                >
                  <option value="">Select Country</option>
                  {countryList?.map((val) => (
                    <option value={val.name}>{val.name}</option>
                  ))}
                </select>
                {errors?.country?.type === "required" && (
                  <label>
                    <span className="mandatory">
                      {errors?.country?.message}
                    </span>
                  </label>
                )}
              </div>
              <div className="col-md-6 form-input">
                <label className="mb-2">
                  City<span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  name="city"
                  placeholder="Enter City"
                  ref={register({
                    required: "Please add city",
                  })}
                  onChange={handleCityInputChange}
                />
                {filteredCities?.length > 0 && (
                  <>
                    <div
                      className="close-suggestion"
                      onClick={handleCitySuggestionClose}
                    ></div>
                    <ul className="city-suggestion-list">
                      {filteredCities?.map((city, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            setValue("city", city);
                            setFilteredCities([]);
                          }}
                          className="city-suggestion-item"
                        >
                          {city}
                        </li>
                      ))}
                    </ul>
                  </>
                )}
                {errors?.city?.type === "required" && (
                  <label>
                    <span className="mandatory">{errors?.city?.message}</span>
                  </label>
                )}
              </div>
              <div className="col-md-6 form-input">
                <label className="mb-2">
                  Category<span className="mandatory">*</span>
                </label>
                <select
                  as="select"
                  name="category"
                  placeholder="Enter Category"
                  ref={register({
                    required: "Please select Category",
                  })}
                  onChange={onCategoryChange}
                >
                  <option value="">Select Category</option>

                  {ticketContentData?.categories?.map((val) => (
                    <option value={val.category}>{val.category}</option>
                  ))}
                </select>
                {errors?.category?.type === "required" && (
                  <label>
                    <span className="mandatory">
                      {errors?.category?.message}
                    </span>
                  </label>
                )}
              </div>
              <div className="col-md-6 form-input">
                <label className="mb-2">
                  Sub-Category<span className="mandatory">*</span>
                </label>
                <select
                  as="select"
                  name="subCategory"
                  placeholder="Enter Sub Category"
                  ref={register({
                    required: "Please select Category",
                  })}
                >
                  <option value="">Select Sub Category</option>
                  {subCategories.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {errors?.subCategory?.type === "required" && (
                  <label>
                    <span className="mandatory">
                      {errors?.subCategory?.message}
                    </span>
                  </label>
                )}
              </div>
              <div className="col-md-6 form-input">
                <label className="mb-2">
                  Description<span className="mandatory">*</span>
                </label>
                <textarea
                  name="description"
                  placeholder="Enter Description"
                  maxLength={600}
                  ref={register({
                    required: "Please add description",
                  })}
                ></textarea>
                {errors?.description?.type === "required" && (
                  <label>
                    <span className="mandatory">
                      {errors?.description?.message}
                    </span>
                  </label>
                )}
              </div>
              <div className="col-md-6 form-input">
                <label>
                  Document Uploaded
                  <span className="mandatory">*</span>
                </label>
                <div className="position-relative add-ride">
                  <label className="file">
                    <input
                      type="file"
                      name="document_upload"
                      placeholder="Upload"
                      accept={acceptDocumentUploadValidation}
                      ref={register({
                        required: "please select a document",
                      })}
                      onChange={handleSelectImages}
                      onClick={(e) => (e.target.value = "")}
                    />
                    <span className="file-custom"></span>
                    <span className="upload-file-name">
                      {ticketFile ? ticketFile : "Upload"}
                    </span>
                  </label>
                </div>
                {errors?.document_upload?.type === "required" && (
                  <label>
                    <span className="mandatory">
                      {errors?.document_upload?.message}
                    </span>
                  </label>
                )}
                <label>Format: Jpg, png, jpeg, pdf</label>
              </div>
              <div className="col-md-7 form-input pl-0">
                <p className="checkbox-sec">
                  <input
                    type="checkbox"
                    id="acceptTC"
                    name="acceptTC"
                    ref={register({
                      required: "Please accept the Terms & Conditions ",
                    })}
                    onChange={(e) => handleCheckTC(e)}
                  />
                  <label
                    for="acceptTC"
                    className="onboardTnC tour-disc-label mr-1"
                  >
                    I have read and accepted the{" "}
                  </label>
                  <span
                    role="button"
                    onClick={() => setShowTC(true)}
                    className="tncBtn ml-5 ml-sm-0"
                  >
                    Terms & Conditions
                  </span>{" "}
                  <span>and the</span>{" "}
                  <span
                    onClick={() => setShowPP(true)}
                    role="button"
                    className="tncBtn"
                  >
                    Privacy Policy
                  </span>
                </p>
              </div>
              <div className="col-md-12">
                <hr className="mx-0" />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-input text-center pt-5">
                  <button
                    className="btn-arrow-border btn-submit-black"
                    disabled={!isTCChecked}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="verify-area pdfPass-modal ticket-modal"
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="small-modal verify-mobile-modal indi-otp pb-0">
              <p className="px-3">Are you a registered Royal Enfield Partner</p>
              <button
                className="btn close-modal"
                type="button"
                onClick={handleClose}
              >
                <img src={closeIcon} alt="close icon" />{" "}
              </button>
              <div className="pdf-container mt-5">
                <div className="btn-grp d-flex flex-wrap align-items-center justify-content-center">
                  <button
                    type="button"
                    class="btn-secondary m-0 mx-3"
                    onClick={handleClose}
                  >
                    No
                  </button>
                  <button
                    className="btn btn-arrow-border btn-submit-black my-3"
                    onClick={(e) => handlePartnerLogin(e)}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <TermConditionModal
          show={showTC}
          onHide={() => setShowTC(false)}
          type={""}
          setValue={setValue}
          getValues={getValues}
        />
        <PrivacyPolicyModal show={showPP} onHide={() => setShowPP(false)} />
      </div>
    </>
  );
};

const AddNewTicket = (props) => (
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
  >
    <AddNewTicketComponent {...props} />
  </GoogleReCaptchaProvider>
);

export default AddNewTicket;
